import React, { useEffect, useRef, useState } from 'react'
import QRCode from 'qrcode'
import './QrPreview.css'

const QrPreview = ({ value, filename = 'qrcode.png', size = 240 }) => {
  const canvasRef = useRef(null)
  const [dataUrl, setDataUrl] = useState('')

  useEffect(() => {
    if (!value || !canvasRef.current) return undefined
    let cancelled = false

    QRCode.toCanvas(canvasRef.current, value, { width: size, margin: 1 })
    QRCode.toDataURL(value, { width: size, margin: 1 }).then((url) => {
      if (!cancelled) setDataUrl(url)
    })

    return () => {
      cancelled = true
    }
  }, [value, size])

  const download = () => {
    const link = document.createElement('a')
    link.href = dataUrl
    link.download = filename
    link.click()
  }

  if (!value) return null

  return (
    <div className="qr-preview">
      <div className="qr-preview-canvas">
        <canvas ref={canvasRef} />
      </div>
      <button
        type="button"
        className="tool-button tool-button-secondary"
        onClick={download}
        disabled={!dataUrl}
      >
        Baixar PNG
      </button>
    </div>
  )
}

export default QrPreview
